import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"

import { useAuth } from "src/context/AuthContext"

export function useToDoList() {
  const { api, isAuthenticated, sponsorId } = useAuth()
  return useQuery({
    queryFn: async () => {
      const response = await api.getToDoList()
      if (response.kind !== "ok") {
        throw new Error("Failed to fetch todos")
      }
      return response.list
    },
    queryKey: ["todos"],
    enabled: !!api && isAuthenticated && !!sponsorId && sponsorId !== "unknown-sponsor",
  })
}

export function useClearTodoList() {
  const { api } = useAuth()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async () => {
      const response = await api.clearToDoList()
      if (response.kind !== "ok") {
        throw new Error("Failed to clear todos")
      }
      return true
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["todos"] })
    },
  })
}
